<template>
  <div :style="styles.base" ref="questionnaireOuter">
    <div v-if="isFromDlg">
      <c-button ref="button" :style="computedStyle" v-bind="$props"></c-button>
    </div>
    <c-dialog v-model="isFormShow" :option="formOption"
      @close="closeBtnClick"
      @confirm="closeBtnClick"
      @cancel="closeBtnClick" v-transfer-dom>
      <template slot="body">
        <div :class="getCss('questionnaire-outer')" :style="bgImage">
          <div :class="getCss('content')">
            <div :class="getCss('content-dlg-info')">
              <div :class="getCss('content-import-questionnaire')">
                <!-- 单选 授权 -->
                <div v-if="isAuth && authPosition === 'top'">
                  <div @click="checkAuthRadio" >
                    <div :class="getCss('questionnaire-auth-radio')" :style="styles.authStyle">
                      <span :class="getCss('radio-auth-radius')">
                        <span :class="
                            getCss(
                              authStatus
                                ? 'checked_icon_auth_radio'
                                : ''
                            )
                          " :style="checkStyle"></span>
                      </span>
                      <span>{{ authText }}</span>
                    </div>
                  </div>
                </div>
                <div v-for="(question, quesIndex) in configurationData.questionConfig" :key="quesIndex"
                  :style="marginHeight" :class="getCss('content-questionnaire-item')">
                  <!-- 输入框 -->
                  <div v-if="question.type === 'input'" :class="getCss(layout === 'inline' ? 'inline' : '')">
                    <div :class="getCss('questionnaire-label')" :style="
                        configurationData.titleAlignRight
                          ? [styles.configStyle, formTitle]
                          : styles.configStyle
                      ">
                      <span v-if="question.isRequired" :style="isRequiredColor">*</span>{{ question.title }}
                    </div>
                    <div :class="
                        getCss(layout === 'inline' ? 'questionnaire-input' : '')
                      ">
                      <input type="text" v-model="
                          data[
                            question.key === 'custom'
                              ? question.inputKey
                              : question.key
                          ]
                        " maxlength="500" @input="
                          inputChange(
                            question.key === 'custom'
                              ? question.inputKey
                              : question.key
                          )
                        " :class="getCss('questionnaire-input-content')" :style="inputStyle" />
                    </div>
                  </div>

                  <!-- 多文本输入框 -->
                  <div v-if="question.type === 'textarea'" :class="getCss(layout === 'inline' ? 'inline' : '')">
                    <div :class="getCss('questionnaire-label')" :style="
                        configurationData.titleAlignRight
                          ? [styles.configStyle, formTitle]
                          : styles.configStyle
                      ">
                      <span v-if="question.isRequired" :style="isRequiredColor">*</span>{{ question.title }}
                    </div>
                    <div :class="
                        getCss(layout === 'inline' ? 'questionnaire-input' : '')
                      ">
                      <textarea v-model="
                          data[
                            question.key === 'custom'
                              ? question.inputKey
                              : question.key
                          ]
                        " :class="getCss('textarea')" @input="
                          inputChange(
                            question.key === 'custom'
                              ? question.inputKey
                              : question.key
                          )
                        " :style="textareaStyle"></textarea>
                    </div>
                  </div>

                  <!-- 单选 下拉框 -->
                  <div v-if="question.type === 'radio'" :class="getCss(layout === 'inline' ? 'inline' : '')">
                    <div :class="getCss('questionnaire-label')" :style="
                        configurationData.titleAlignRight
                          ? [styles.configStyle, formTitle]
                          : styles.configStyle
                      ">
                      <span v-if="question.isRequired" :style="isRequiredColor">*</span>{{ question.title }}
                    </div>
                    <div v-if="question.arrange === 'list'" :class="
                        getCss(
                          layout === 'inline'
                            ? ['inlineStyle', 'radio-justify-content']
                            : ''
                        )
                      ">
                      <div v-for="(item, index) in question.option.split(/[\n\s+,]/g)" :key="index"
                        :class="getCss('questionnaire-input-radio')" @click="
                          checkRadio(
                            question.key === 'custom'
                              ? question.inputKey
                              : question.key,
                            item
                          )
                        " :style="styles.optionStyle">
                        <span :class="getCss('radio-border-radius')">
                          <span :class="
                              getCss(
                                !isShowMask
                                  ? 'checked_icon_radio'
                                  : data[
                                      question.key === 'custom'
                                        ? question.inputKey
                                        : question.key
                                    ] === item
                                  ? 'checked_icon_radio'
                                  : ''
                              )
                            " :style="checkStyle"></span>
                        </span>
                        {{ item }}
                      </div>
                    </div>
                    <div v-else-if="question.arrange === 'select'" :class="
                        getCss(
                          layout === 'inline'
                            ? 'bir-area-select'
                            : styles.selectRightIcon.backgroundImage
                            ? ''
                            : 'area-select'
                        )
                      " :style="areaStyle">
                      <select v-model="
                          data[
                            question.key === 'custom'
                              ? question.inputKey
                              : question.key
                          ]
                        " name="question" :class="getCss('questionnaire-input-content')"
                        :style="[inputStyle, selectRightIcon]">
                        <option v-for="(item, index) in question.option.split(
                            /[\n\s+,]/g
                          )" :value="item" :key="index" :class="getCss('select-option')">
                          {{ item }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- 多选 下拉框 -->
                  <div v-if="question.type === 'checkbox'" :class="getCss(layout === 'inline' ? 'inline' : '')">
                    <div :class="getCss('questionnaire-label')" :style="
                        configurationData.titleAlignRight
                          ? [styles.configStyle, formTitle]
                          : styles.configStyle
                      ">
                      <span v-if="question.isRequired" :style="isRequiredColor">*</span>{{ question.title }}
                    </div>
                    <div v-if="question.arrange === 'list'" :class="
                        getCss(
                          layout === 'inline'
                            ? ['inlineStyle', 'radio-justify-content']
                            : ''
                        )
                      ">
                      <div v-for="(item, index) in question.option.split(/[\n\s+,]/g)" :key="index"
                        :class="getCss('questionnaire-input-checkbox')" @click="
                          checkCheckbox(
                            question.key === 'custom'
                              ? question.inputKey
                              : question.key,
                            item,
                            question.maxNum
                          )
                        " :style="styles.optionStyle">
                        <span :class="getCss('checked_icon_wrap_checkbox')">
                          <span :class="
                              getCss(
                                !isShowMask
                                  ? 'checked_icon_checkbox'
                                  : data[
                                      question.key === 'custom'
                                        ? question.inputKey
                                        : question.key
                                    ].includes(item)
                                  ? 'checked_icon_checkbox'
                                  : ''
                              )
                            " :style="checkStyle"></span>
                        </span>
                        {{ item }}
                      </div>
                    </div>
                    <div v-else-if="question.arrange === 'select'" :class="
                        getCss(
                          layout === 'inline'
                            ? 'bir-area-select position'
                            : 'area-select position'
                        )
                      " :style="areaStyle">
                      <select v-model="
                          data[
                            question.key === 'custom'
                              ? question.inputKey
                              : question.key
                          ]
                        " name="question" :class="getCss('questionnaire-input-content')" multiple @change="
                          (event) => {
                            multipleChange(
                              event,
                              question.key === 'custom'
                                ? question.inputKey
                                : question.key,
                              question.maxNum
                            );
                          }
                        " :style="inputStyle">
                        <option v-for="(item, index) in question.option.split(
                            /[\n\s+,]/g
                          )" :disabled="
                            data[
                              question.key === 'custom'
                                ? question.inputKey
                                : question.key
                            ].length >= question.maxNum &&
                            !data[
                              question.key === 'custom'
                                ? question.inputKey
                                : question.key
                            ].includes(item)
                          " :value="item" :key="index" @click="
                            (event) => {
                              multipleChange(
                                event,
                                question.key === 'custom'
                                  ? question.inputKey
                                  : question.key,
                                question.maxNum
                              );
                            }
                          " :class="getCss('select-option')" choose>
                          {{ item }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- 时间选择器 -->
                  <div v-if="question.type === 'datepicker'" :class="getCss(layout === 'inline' ? 'inline' : '')">
                    <div :class="getCss('questionnaire-label')" :style="
                        configurationData.titleAlignRight
                          ? [styles.configStyle, formTitle]
                          : styles.configStyle
                      ">
                      <span v-if="question.isRequired" :style="isRequiredColor">*</span>{{ question.title }}
                    </div>
                    <data-select :cascaderLabelStyle="cascaderLabelStyle"
                      :isHidingMinors="configurationData.isHidingMinors"
                      :option="cascaderStyle" :birthdayInfo="birthdayInfo" @setBirthDay="
                        (birthdayInfo) => {
                          setBirthDay(
                            birthdayInfo,
                            question.key === 'custom'
                              ? question.inputKey
                              : question.key
                          );
                        }
                      "></data-select>
                  </div>

                  <!-- 地址选择器 -->
                  <div v-if="question.type === 'site'" :class="getCss(layout === 'inline' ? 'inline' : '')">
                    <div :class="getCss('questionnaire-label')" :style="
                        configurationData.titleAlignRight
                          ? [styles.configStyle, formTitle]
                          : styles.configStyle
                      ">
                      <span v-if="question.isRequired" :style="isRequiredColor">*</span>{{ question.title }}
                    </div>
                    <city-select :option="cascaderStyle" :cascaderLabelStyle="cascaderLabelStyle" :siteInfo="siteInfo"
                      @setSite="
                        (siteInfo) => {
                          setSite(
                            siteInfo,
                            question.key === 'custom'
                              ? question.inputKey
                              : question.key
                          );
                        }
                      "></city-select>
                  </div>

                  <!-- 带验证码版本手机绑定 -->
                  <div v-if="question.type === 'bindPhoneCode'">
                    <div :class="getCss(['bind-phone-num', layout === 'inline' ? 'inline' : ''])">
                      <div :class="getCss('questionnaire-label')" :style="
                          configurationData.titleAlignRight
                            ? [styles.configStyle, formTitle]
                            : styles.configStyle
                        ">
                        <span v-if="question.isRequired" :style="isRequiredColor">*</span>手机号：
                      </div>
                      <div :class="
                          getCss(layout === 'inline' ? 'questionnaire-input' : '')
                        ">
                        <input type="text" v-model="
                            data[
                              question.key === 'custom'
                                ? question.inputKey
                                : question.key
                            ]
                          " maxlength="500" @input="
                            inputChange(
                              question.key === 'custom'
                                ? question.inputKey
                                : question.key
                            )
                          " :class="getCss('questionnaire-input-content')" :style="inputStyle" />
                      </div>
                    </div>
                    <div :class="getCss(layout === 'inline' ? 'inline' : '')">
                      <div :class="getCss('questionnaire-label')" :style="
                          configurationData.titleAlignRight
                            ? [styles.configStyle, formTitle]
                            : styles.configStyle
                        ">
                        <span v-if="question.isRequired" :style="isRequiredColor">*</span>验证码：
                      </div>
                      <div :class="
                          getCss('bind-phone-num-code')
                        ">
                        <input type="text" v-model="verificationCode" maxlength="500" @input="
                            inputChange(
                              question.key === 'custom'
                                ? question.inputKey
                                : question.key
                            )
                          " :class="getCss('questionnaire-input-content')" :style="getCodeInputStyle" />

                        <div :class="getCss(['click-btn-active','click-btn'])" :style="codeInputStyle">
                          <!-- <c-button ref="getCodeButton" :style="bindBtnBgImage" v-bind="$props" /> -->
                          <c-button ref="getCodeButton" v-show="codeTime === 0"
                            :style="getCodeButton" v-bind="$props" />
                          <div
                            :class="getCss('count-down-second')"
                            :style="seeCodeButton"
                            v-show="codeTime > 0">剩余{{codeTime}}秒
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 单选 授权 -->
                <div v-if="isAuth && authPosition === 'bot'">
                  <div @click="checkAuthRadio">
                    <div :class="getCss('questionnaire-auth-radio')" :style="styles.authStyle">
                      <span :class="getCss('radio-auth-radius')">
                        <span :class="
                            getCss(
                              authStatus
                                ? 'checked_icon_auth_radio'
                                : ''
                            )
                          " :style="checkStyle"></span>
                      </span>
                      <span>{{ authText }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>

          </div>
          <div :class="getCss('footer')" :style="
              configurationData.isCenter ? [btnMarginTop, btnCenter] : btnMarginTop
            ">
            <c-button ref="inviteButton" :style="bindBtnBgImage" v-bind="$props" />
            <!-- <c-button ref="getCodeButton" :style="bindBtnBgImage" v-bind="$props" /> -->
          </div>
        </div>
      </template>
    </c-dialog>
    <div v-if="!isFromDlg" :class="getCss('questionnaire-outer')" :style="bgImage">
        <div :class="getCss('content')">
          <div :class="getCss('content-info')">
            <div :class="getCss('content-import-questionnaire')">
              <!-- 单选 授权 -->
              <div v-if="isAuth && authPosition === 'top'">
                <div @click="checkAuthRadio">
                  <div :class="getCss('questionnaire-auth-radio')" :style="styles.authStyle">
                    <span :class="getCss('radio-auth-radius')">
                      <span :class="
                          getCss(
                            authStatus
                              ? 'checked_icon_auth_radio'
                              : ''
                          )
                        " :style="checkStyle"></span>
                    </span>
                    <span>{{ authText }}</span>
                  </div>
                </div>
              </div>
              <div v-for="(question, quesIndex) in configurationData.questionConfig" :key="quesIndex"
                :style="marginHeight" :class="getCss('content-questionnaire-item')">
                <!-- 输入框 -->
                <div v-if="question.type === 'input'" :class="getCss(layout === 'inline' ? 'inline' : '')">
                  <div :class="getCss('questionnaire-label')" :style="
                      configurationData.titleAlignRight
                        ? [styles.configStyle, formTitle]
                        : styles.configStyle
                    ">
                    <span v-if="question.isRequired" :style="isRequiredColor">*</span>{{ question.title }}
                  </div>
                  <div :class="
                      getCss(layout === 'inline' ? 'questionnaire-input' : '')
                    ">
                    <input type="text" v-model="
                        data[
                          question.key === 'custom'
                            ? question.inputKey
                            : question.key
                        ]
                      " maxlength="500" @input="
                        inputChange(
                          question.key === 'custom'
                            ? question.inputKey
                            : question.key
                        )
                      " :class="getCss('questionnaire-input-content')" :style="inputStyle" />
                  </div>
                </div>

                <!-- 多文本输入框 -->
                <div v-if="question.type === 'textarea'" :class="getCss(layout === 'inline' ? 'inline' : '')">
                  <div :class="getCss('questionnaire-label')" :style="
                      configurationData.titleAlignRight
                        ? [styles.configStyle, formTitle]
                        : styles.configStyle
                    ">
                    <span v-if="question.isRequired" :style="isRequiredColor">*</span>{{ question.title }}
                  </div>
                  <div :class="
                      getCss(layout === 'inline' ? 'questionnaire-input' : '')
                    ">
                    <textarea v-model="
                        data[
                          question.key === 'custom'
                            ? question.inputKey
                            : question.key
                        ]
                      " :class="getCss('textarea')" @input="
                        inputChange(
                          question.key === 'custom'
                            ? question.inputKey
                            : question.key
                        )
                      " :style="textareaStyle"></textarea>
                  </div>
                </div>

                <!-- 单选 下拉框 -->
                <div v-if="question.type === 'radio'" :class="getCss(layout === 'inline' ? 'inline' : '')">
                  <div :class="getCss('questionnaire-label')" :style="
                      configurationData.titleAlignRight
                        ? [styles.configStyle, formTitle]
                        : styles.configStyle
                    ">
                    <span v-if="question.isRequired" :style="isRequiredColor">*</span>{{ question.title }}
                  </div>
                  <div v-if="question.arrange === 'list'" :class="
                      getCss(
                        layout === 'inline'
                          ? ['inlineStyle', 'radio-justify-content']
                          : ''
                      )
                    ">
                    <div v-for="(item, index) in question.option.split(/[\n\s+,]/g)" :key="index"
                      :class="getCss('questionnaire-input-radio')" @click="
                        checkRadio(
                          question.key === 'custom'
                            ? question.inputKey
                            : question.key,
                          item
                        )
                      " :style="styles.optionStyle">
                      <span :class="getCss('radio-border-radius')">
                        <span :class="
                            getCss(
                              !isShowMask
                                ? 'checked_icon_radio'
                                : data[
                                    question.key === 'custom'
                                      ? question.inputKey
                                      : question.key
                                  ] === item
                                ? 'checked_icon_radio'
                                : ''
                            )
                          " :style="checkStyle"></span>
                      </span>
                      {{ item }}
                    </div>
                  </div>
                  <div v-else-if="question.arrange === 'select'" :class="
                      getCss(
                        layout === 'inline'
                          ? 'bir-area-select'
                          : styles.selectRightIcon.backgroundImage
                          ? ''
                          : 'area-select'
                      )
                    " :style="areaStyle">
                    <select v-model="
                        data[
                          question.key === 'custom'
                            ? question.inputKey
                            : question.key
                        ]
                      " name="question" :class="getCss('questionnaire-input-content')"
                      :style="[inputStyle, selectRightIcon]">
                      <option v-for="(item, index) in question.option.split(
                          /[\n\s+,]/g
                        )" :value="item" :key="index" :class="getCss('select-option')">
                        {{ item }}
                      </option>
                    </select>
                  </div>
                </div>

                <!-- 多选 下拉框 -->
                <div v-if="question.type === 'checkbox'" :class="getCss(layout === 'inline' ? 'inline' : '')">
                  <div :class="getCss('questionnaire-label')" :style="
                      configurationData.titleAlignRight
                        ? [styles.configStyle, formTitle]
                        : styles.configStyle
                    ">
                    <span v-if="question.isRequired" :style="isRequiredColor">*</span>{{ question.title }}
                  </div>
                  <div v-if="question.arrange === 'list'" :class="
                      getCss(
                        layout === 'inline'
                          ? ['inlineStyle', 'radio-justify-content']
                          : ''
                      )
                    ">
                    <div v-for="(item, index) in question.option.split(/[\n\s+,]/g)" :key="index"
                      :class="getCss('questionnaire-input-checkbox')" @click="
                        checkCheckbox(
                          question.key === 'custom'
                            ? question.inputKey
                            : question.key,
                          item,
                          question.maxNum
                        )
                      " :style="styles.optionStyle">
                      <span :class="getCss('checked_icon_wrap_checkbox')">
                        <span :class="
                            getCss(
                              !isShowMask
                                ? 'checked_icon_checkbox'
                                : data[
                                    question.key === 'custom'
                                      ? question.inputKey
                                      : question.key
                                  ].includes(item)
                                ? 'checked_icon_checkbox'
                                : ''
                            )
                          " :style="checkStyle"></span>
                      </span>
                      {{ item }}
                    </div>
                  </div>
                  <div v-else-if="question.arrange === 'select'" :class="
                      getCss(
                        layout === 'inline'
                          ? 'bir-area-select position'
                          : 'area-select position'
                      )
                    " :style="areaStyle">
                    <select v-model="
                        data[
                          question.key === 'custom'
                            ? question.inputKey
                            : question.key
                        ]
                      " name="question" :class="getCss('questionnaire-input-content')" multiple @change="
                        (event) => {
                          multipleChange(
                            event,
                            question.key === 'custom'
                              ? question.inputKey
                              : question.key,
                            question.maxNum
                          );
                        }
                      " :style="inputStyle">
                      <option v-for="(item, index) in question.option.split(
                          /[\n\s+,]/g
                        )" :disabled="
                          data[
                            question.key === 'custom'
                              ? question.inputKey
                              : question.key
                          ].length >= question.maxNum &&
                          !data[
                            question.key === 'custom'
                              ? question.inputKey
                              : question.key
                          ].includes(item)
                        " :value="item" :key="index" @click="
                          (event) => {
                            multipleChange(
                              event,
                              question.key === 'custom'
                                ? question.inputKey
                                : question.key,
                              question.maxNum
                            );
                          }
                        " :class="getCss('select-option')" choose>
                        {{ item }}
                      </option>
                    </select>
                  </div>
                </div>

                <!-- 时间选择器 -->
                <div v-if="question.type === 'datepicker'" :class="getCss(layout === 'inline' ? 'inline' : '')">
                  <div :class="getCss('questionnaire-label')" :style="
                      configurationData.titleAlignRight
                        ? [styles.configStyle, formTitle]
                        : styles.configStyle
                    ">
                    <span v-if="question.isRequired" :style="isRequiredColor">*</span>{{ question.title }}
                  </div>
                  <data-select :cascaderLabelStyle="cascaderLabelStyle"
                    :isHidingMinors="configurationData.isHidingMinors"
                    :option="cascaderStyle" :birthdayInfo="birthdayInfo" @setBirthDay="
                      (birthdayInfo) => {
                        setBirthDay(
                          birthdayInfo,
                          question.key === 'custom'
                            ? question.inputKey
                            : question.key
                        );
                      }
                    "></data-select>
                </div>

                <!-- 地址选择器 -->
                <div v-if="question.type === 'site'" :class="getCss(layout === 'inline' ? 'inline' : '')">
                  <div :class="getCss('questionnaire-label')" :style="
                      configurationData.titleAlignRight
                        ? [styles.configStyle, formTitle]
                        : styles.configStyle
                    ">
                    <span v-if="question.isRequired" :style="isRequiredColor">*</span>{{ question.title }}
                  </div>
                  <city-select :option="cascaderStyle" :cascaderLabelStyle="cascaderLabelStyle" :siteInfo="siteInfo"
                    @setSite="
                      (siteInfo) => {
                        setSite(
                          siteInfo,
                          question.key === 'custom'
                            ? question.inputKey
                            : question.key
                        );
                      }
                    "></city-select>
                </div>

                <!-- 带验证码版本手机绑定 -->
                <div v-if="question.type === 'bindPhoneCode'">
                  <div :class="getCss(['bind-phone-num', layout === 'inline' ? 'inline' : ''])">
                    <div :class="getCss('questionnaire-label')" :style="
                        configurationData.titleAlignRight
                          ? [styles.configStyle, formTitle]
                          : styles.configStyle
                      ">
                      <span v-if="question.isRequired" :style="isRequiredColor">*</span>手机号：
                    </div>
                    <div :class="
                        getCss(layout === 'inline' ? 'questionnaire-input' : '')
                      ">
                      <input type="text" v-model="
                          data[
                            question.key === 'custom'
                              ? question.inputKey
                              : question.key
                          ]
                        " maxlength="500" @input="
                          inputChange(
                            question.key === 'custom'
                              ? question.inputKey
                              : question.key
                          )
                        " :class="getCss('questionnaire-input-content')" :style="inputStyle" />
                    </div>
                  </div>
                  <div :class="getCss(layout === 'inline' ? 'inline' : '')">
                    <div :class="getCss('questionnaire-label')" :style="
                        configurationData.titleAlignRight
                          ? [styles.configStyle, formTitle]
                          : styles.configStyle
                      ">
                      <span v-if="question.isRequired" :style="isRequiredColor">*</span>验证码：
                    </div>
                    <div :class="
                        getCss('bind-phone-num-code')
                      ">
                      <input type="text" v-model="verificationCode" maxlength="500" @input="
                          inputChange(
                            question.key === 'custom'
                              ? question.inputKey
                              : question.key
                          )
                        " :class="getCss('questionnaire-input-content')" :style="getCodeInputStyle" />

                      <div :class="getCss(['click-btn-active','click-btn'])" :style="codeInputStyle">
                        <!-- <c-button ref="getCodeButton" :style="bindBtnBgImage" v-bind="$props" /> -->
                        <c-button ref="getCodeButton" v-show="codeTime === 0" :style="getCodeButton" v-bind="$props" />
                        <div
                          :class="getCss('count-down-second')"
                          :style="seeCodeButton"
                          v-show="codeTime > 0">剩余{{codeTime}}秒
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div v-if="isAuth && authPosition === 'bot'">
                <div @click="checkAuthRadio" >
                  <div :class="getCss('questionnaire-auth-radio')" :style="styles.authStyle">
                    <span :class="getCss('radio-auth-radius')">
                      <span :class="
                          getCss(
                            authStatus
                              ? 'checked_icon_auth_radio'
                              : ''
                          )
                        " :style="checkStyle"></span>
                    </span>
                    <span>{{ authText }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>

        </div>
        <div :class="getCss('footer')" :style="
            configurationData.isCenter ? [btnMarginTop, btnCenter] : btnMarginTop
          ">
          <c-button ref="inviteButton" :style="bindBtnBgImage" v-bind="$props" />
          <!-- <c-button ref="getCodeButton" :style="bindBtnBgImage" v-bind="$props" /> -->
        </div>
    </div>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';
// import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
import CDialog from '@tencent/ceiba-base-components/src/components/ceiba-dialog';
import DataSelect from './data-select.vue';
import CitySelect from './city-select.vue';
export default {
  name: 'CGenericFormComponent',
  components: {
    [button.name]: button,
    [CDialog.name]: CDialog,
    DataSelect,
    CitySelect,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'public-generic-form-component-',
      data: {},
      isShowPop: true,
      check: true,
      authorization: false,
      flowId: 0,
      birMsg: '',
      OptionListVisible: false,
      siteInfo: {
        province: '',
        city: '',
        area: '',
      },
      birthdayInfo: {
        year: null,
        month: null,
        day: null,
      },
      phone: '',
      codeTime: 0,     // 倒计时
      timeClock: 0,
      verificationCode: '',   // 验证码
      lock: false,
      formStatus: 'applied', // apply applied
      isFormShow: false,
      authStatus: true,
    };
  },
  computed: {
    popOption() {
      return Object.assign({}, this.dialogConfig, {
        header: '温馨提示',
        footer: false,
      });
    },
    // 按钮
    getCodeButton() {
      const { sendCodeBtn } = this.configurationData;
      return {
        backgroundImage: `url(${sendCodeBtn || ''})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        width: '100%',
        height: '100%',
        top: '0',
        left: '0',
        position: 'static',
        display: 'block',
      };
    },
    layout() {
      return this.configurationData.layout;
    },
    isRequiredColor() {
      return {
        color: this.configurationData.isRequiredColor,
      };
    },
    formTitle() {
      return {
        textAlign: 'right',
        width: `${this.styles.formTitleStyle.width / 100}rem`,
      };
    },
    selectRightIcon() {
      return {
        backgroundImage: `url(${this.styles.selectRightIcon.backgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: this.styles.selectRightIcon.backgroundSize,
        backgroundPosition: 'right',
        appearance: 'none',
      };
    },
    // 多文本样式
    textareaStyle() {
      return {
        fontSize: this.styles.inputStyle.fontSize,
        fontFamily: this.styles.inputStyle.fontFamily,
        backgroundColor: this.styles.inputStyle.backgroundColor,
        color: this.styles.inputStyle.color,
        width: `${this.styles.textareaStyle.width / 100}rem`,
        height: `${this.styles.textareaStyle.height / 100}rem`,
      };
    },
    areaStyle() {
      return {
        width: `${this.styles.inputStyle.width / 100}rem`,
      };
    },
    marginHeight() {
      return {
        margin: `${this.styles.configStyle.marginHeight / 100}rem 0`,
      };
    },
    activeCodeBtn() {
      return {
        fontSize: this.styles.inputStyle.fontSize,
        fontFamily: this.styles.inputStyle.fontFamily,
        backgroundColor: this.styles.inputStyle.backgroundColor,
        color: this.styles.inputStyle.color,
        height: `${this.styles.inputStyle.height / 100}rem`,
      };
    },
    seeCodeButton() {
      return {
        backgroundColor: this.styles.codeStyle.backgroundColor,
      };
    },
    codeInputStyle() {
      return {
        fontSize: this.styles.codeStyle.fontSize,
        color: this.styles.codeStyle.color,
        height: `${this.styles.inputStyle.height / 100}rem`,
        width: `${this.styles.codeStyle.width / 100}rem`,
      };
    },
    getCodeInputStyle() {
      return {
        fontSize: this.styles.inputStyle.fontSize,
        fontFamily: this.styles.codeStyle.fontFamily,
        backgroundColor: this.styles.inputStyle.backgroundColor,
        color: this.styles.inputStyle.color,
        height: `${this.styles.inputStyle.height / 100}rem`,
        width: `${(this.styles.inputStyle.width - this.styles.codeStyle.width) / 100 - 0.1}rem`,
      };
    },
    inputStyle() {
      return {
        fontSize: this.styles.inputStyle.fontSize,
        fontFamily: this.styles.inputStyle.fontFamily,
        backgroundColor: this.styles.inputStyle.backgroundColor,
        color: this.styles.inputStyle.color,
        height: `${this.styles.inputStyle.height / 100}rem`,
        width: `${this.styles.inputStyle.width / 100}rem`,
        borderRadius: '0.06rem',
      };
    },
    cascaderLabelStyle() {
      return {
        fontSize: this.styles.configStyle.fontSize,
        fontFamily: this.styles.configStyle.fontFamily,
        color: this.styles.configStyle.color,
      };
    },
    cascaderStyle() {
      return {
        fontSize: this.styles.inputStyle.fontSize,
        fontFamily: this.styles.inputStyle.fontFamily,
        backgroundColor: this.styles.inputStyle.backgroundColor,
        color: this.styles.inputStyle.color,
        height: `${this.configurationData.dataPickerHeight / 100}rem`,
        width: `${this.configurationData.dataPickerWidth / 100}rem`,
        borderRadius: '0.06rem',
      };
    },
    isShowMask() {
      return !this.$isInEditor || this.isInPreview;
    },
    pureBaseStyle() {
      return {
        left: this.styles.base.left,
        top: this.styles.base.top,
        width: this.styles.base.width,
        height: this.styles.base.height,
      };
    },
    bgImage() {
      const { integralPaddingTop } = this.configurationData;
      let heightStyle = {
        height: this.styles.base.height,
      };
      // 弹窗模式不需要高度，由组件自动撑开
      if (this.isFromDlg) {
        heightStyle = {};
      }
      return {
        width: this.isFromDlg ? '100%' : this.styles.base.width,
        ...heightStyle,
        paddingTop: `${integralPaddingTop / 100}rem`,
        backgroundImage: `url(${this.configurationData.bgImage})`,
        backgroundSize: '100% 100%',
      };
    },
    checkStyle() {
      return {
        background: this.configurationData.checkColor,
      };
    },
    btnCenter() {
      return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      };
    },
    btnMarginTop() {
      return {
        marginTop: `${this.configurationData.buttonMarginTop / 100}rem`,
        marginBottom: '0.48rem',
      };
    },
    bindBtnBgImage() {
      return {
        backgroundImage: `url(${this.configurationData.bindBtnBgImage})`,
        width: `${this.configurationData.buttonWidth / 100}rem`,
        height: `${this.configurationData.buttonHeight / 100}rem`,
        backgroundSize: '100% 100%',
        top: '0',
        left: '0',
        position: 'static',
        display: 'block',
        marginLeft: this.configurationData.isCenter
          ? 0
          : `${this.configurationData.buttonMarginLeft / 100}rem`,
      };
    },
    questionConfig() {
      return this.configurationData.questionConfig;
    },
    formTag() {
      return this.configurationData.from_tag;
    },
    // 弹窗模式
    formOption() {
      return Object.assign({}, this.dialogConfig, {
        width: '6.4rem',
        header: false,
        footer: false,
      });
    },
    backgroundImageMap() {
      return {
        apply: this.configurationData.applyImg,
        applied: this.configurationData.appliedImg,
      };
    },
    computedStyle() {
      const { isStretching, buttonDefaultBackgroundImage = '' } = this.configurationData;
      let backgroundImage = this.backgroundImageMap[this.formStatus];
      if (!!buttonDefaultBackgroundImage) {
        backgroundImage = buttonDefaultBackgroundImage;
      }
      return {
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: isStretching ? '' : 'contain', // 是否拉伸
        backgroundRepeat: 'no-repeat',
        left: 0,
        top: 0,
      };
    },
    enable() {
      const packageStatus = this.quaInfo[this.configurationData.fillFlowID];
      console.log('fillFlowID', this.configurationData.fillFlowID);
      if (!packageStatus) return true;
      return !(packageStatus.total > 0 && packageStatus.remain === 0);
    },
    isFromDlg() {
      return this.configurationData.isFromDlg;
    },
    isAuth() {
      return this.configurationData.isAuth;
    },
    authPosition() {
      return this.configurationData.authPosition;
    },
    authText() {
      return this.configurationData.authText;
    },
    authStyle() {
      return {
        fontSize: this.styles.authStyle.fontSize,
        fontFamily: this.styles.authStyle.fontFamily,
        color: this.styles.authStyle.color,
        fontWeight: this.styles.authStyle.fontWeight,
      };
    },
  },
  created() {
    this.dataInit();
  },
  async mounted() {
    console.log('configurationData=', this.configurationData);
    console.log(this.data);
    await this.initialize();
  },
  methods: {
    initMountedStatus() {
      if (!this.enable) this.formStatus = 'applied';
      else this.formStatus = 'apply';
    },
    async initialize() {
      if (this.$isInEditor) return;
      if (this.configurationData.authorizationCheck) {
        // 点击同意授权获取的状态
        this.$eventBus.$on(
          'ceiba:custom:events:SyncUserContractStatus',
          ({ status }) => {
            console.log(status);
            if (status) {
              this.authorization = true;
            } else {
              this.authorization = false;
            }
          },
        );
      } else {
        this.authorization = true;
      }

      if (this.isAuth) {
        this.authStatus = false;
      }
      if (this.isFromDlg) {
        this.$refs.button.setClickHandler(this.showFormDlg, {
          forceApp: this.configurationData.forceApp,
          forceLogin: true,
          forceRole: this.configurationData.forceRole,
        });
      } else {
        this.$onLogined(async () => {
          await this.query();
        });
        this.initButton();
      }
      this.initMountedStatus();
      // const self = this;
      // const node = this.$refs.questionnaireOuter;
      // /* eslint no-underscore-dangle: ["error", { "allow": ["_prevClass"] }]*/
      // if (node.parentNode && node.parentNode._prevClass !== 'page-content') {
      //   self.query();
      // } else {
      //   this.$onLogined(async () => {
      //     await self.query();
      //   });
      // }
    },
    // multipleBlur() {
    //   this.OptionListVisible = true;
    // },
    // openOptionList() {
    //   this.OptionListVisible = true;
    // },
    /**
       *
       * @param {String} key 传入的单个组件key值
       */
    inputChange(key) {
      if (this.data[key].length >= 500) {
        return this.$toast('文本限制500字');
      }
    },
    /**
       * 多选判断是否超出最多选择值
       * @param {Object} event 默认事件e
       * @param {String} key 传入的单个组件key值
       * @param {Number} maxNum 传入的单个组件maxNum值
       */
    multipleChange(event, key, maxNum) {
      console.log(event.target);
      console.log(event.target.value);
      console.log(this.data[key], this.data[key].length, key, maxNum);
      if (this.data[key].length > maxNum) {
        return this.$toast(`至多选择${maxNum}项`);
      }
    },
    /**
       * 初始化点击事件
       */
    initButton() {
      this.$nextTick(() => {
        this.$refs.inviteButton.setClickHandler(this.doReward, {
          forceApp: this.configurationData.forceApp,
          forceLogin: true,
          forceRole: this.configurationData.forceRole,
        });
        if (this.$refs.getCodeButton) {
          this.$refs.getCodeButton[0].setClickHandler(this.sendVerifyCode, {
            forceApp: this.configurationData.forceApp,
            forceLogin: true,
            forceRole: this.configurationData.forceRole,
          });
        }
      });
    },
    /**
       * 发送验证码
       */
    async sendVerifyCode() {
      for (let index = 0; index < this.questionConfig.length; index++) {
        const pre = this.questionConfig[index];
        if (pre.type === 'bindPhoneCode') {
          if (!this.checkPhoneFormat(this.data[pre.key === 'custom' ? pre.inputKey : pre.key])) {
            return false;
          }

          if (this.phone === this.data[pre.key === 'custom' ? pre.inputKey : pre.key]) {
            this.$alert({ msg: '该手机号已绑定' });
            return false;
          }

          if (this.lock) {
            return false;
          }
          this.lock = true;

          const response = await this.flowRequest({
            flowId: this.configurationData.sendCodeFlowId,
            params: {
              role: this.roleInfo,
              data: JSON.stringify({
                sendPhone: this.data[pre.key === 'custom' ? pre.inputKey : pre.key],
              }),
            },
          });
          const { ret, msg, data = {} }  = response;
          this.lock = false;
          if (ret !== 0) return  this.$alert({ msg: msg || '验证码发送失败' });
          const { ret: resRet, msg: resMsg } = data;
          if (resRet !== 0) return this.$alert({ msg: resMsg || '验证码发送失败' });
          this.$alert({ msg: '验证码发送成功' });
          this.codeTime = this.configurationData.second || 60;
          console.log(this.codeTime);
          const that = this;
          that.timeClock = setInterval(() => {
            this.codeTime = this.codeTime - 1;
            if (this.codeTime === 0) {
              clearInterval(that.timeClock);
            }
          }, 1000);
        }
      }

      // const { ret: resRet, msg: resMsg } = data;
      // if (resRet !== 0) return  this.showAlertMsg(resMsg || '验证码发送失败');
      // this.showToast('验证码发送成功');
    },
    /**
       * 进入页面查询第一次
       */
    async query() {
      // 检测登陆
      if (!this.isLogin) {
        this.alert('请先登录');
        return;
      }
      const { queryFlowID = 0 } = this.configurationData;
      console.log('queryFlowID', queryFlowID);
      if (queryFlowID > 0) {
        const response = await this.flowRequest({
          flowId: this.configurationData.queryFlowID,
          params: {
            role: this.roleInfo,
            data: JSON.stringify({
              form_tag: this.formTag,
            }),
          },
        });
        console.log('response', response);
        if (response.ret === 0 && response.data.ret === 0) {
          const info = JSON.parse(response.data.info);
          const infoData = JSON.parse(info.data);
          console.log('infoData', infoData);
          Object.keys(infoData).forEach((item) => {
            if (infoData) {
              this.data[item] = infoData[item];
            }
          });
          this.configurationData.questionConfig.forEach((item) => {
            const itemKey = item.key === 'custom' ? item.inputKey : item.key;
            // 做时间数据格式处理
            if (item.type === 'datepicker') {
              if (
                Object.keys(this.data).includes(itemKey)
                  && infoData[itemKey]
              ) {
                this.data[itemKey] = infoData[itemKey];
                const birArr = this.data[itemKey].split('-');
                const [year, month, day] = birArr;
                this.birthdayInfo = {
                  year,
                  month,
                  day,
                };
              }
            }
            // 做地址数据格式处理
            if (item.type === 'site') {
              if (
                Object.keys(this.data).includes(itemKey)
                  && infoData[itemKey]
              ) {
                this.data[itemKey] = infoData[itemKey];
                const siteArr = this.data[itemKey].split('-');
                const [province, city, area] = siteArr;
                this.siteInfo = {
                  province,
                  city,
                  area,
                };
              }
            }
            if (item.type === 'bindPhoneCode') {
              this.phone = infoData[itemKey];
            }
          });
          console.log('this.data', this.data);
          this.flowId = this.configurationData.editFlowID;
          this.birMsg = this.configurationData.editMsg;
        } else {
          this.flowId = this.configurationData.fillFlowID;
          this.birMsg = this.configurationData.bindMsg;
        }
      }
    },
    /**
       * 检查手机完整性
       */
    checkPhoneFormat(phone) {
      if (!phone) {
        this.$alert({ msg: '请填写手机号' });
        return false;
      }
      if (!(/^1[3456789]\d{9}$/.test(phone))) {
        this.$alert({ msg: '请填写正确手机号' });
        return false;
      }
      return true;
    },
    /**
       * 检查验证码完整性
       */
    checkVerifyCodeFormat() {
      if (this.verificationCode.toString().length !== 6) {
        this.$alert({ msg: '请填写正确验证码' });
        return false;
      }
      return  true;
    },
    /**
       * 检查验证码完整性
       */
    checkVerifyCodeEmpty() {
      if (!this.verificationCode) {
        this.$alert({ msg: '请输入验证码' });
        return false;
      }
      return  true;
    },
    /**
       * 提交
       */
    async doReward() {
      if (!this.authorization) return this.$toast('请先阅读并同意上述内容');
      if (!this.authStatus) return this.$toast('请先同意授权内容');
      for (let index = 0; index < this.questionConfig.length; index++) {
        const pre = this.questionConfig[index];
        const itemKey = pre.key === 'custom' ? pre.inputKey : pre.key;
        if (pre.isRequired && !this.data[itemKey]) {
          let str = '';
          if (pre.title.includes(':')) {
            [str] = pre.title.split(':');
          } else {
            [str] = pre.title.split('：');
          }
          return this.$alert(`请填写${str}`);  // return this.$toast(`请填写${pre.title}`);
        }
        if (itemKey === 'phone') {
          if (!this.checkPhoneFormat(this.data[itemKey])) {
            return false;
          }
        }
        if (pre.type === 'bindPhoneCode') {
          if (!this.checkPhoneFormat(this.data[itemKey])) {
            return false;
          }
          if (!this.checkVerifyCodeEmpty()) {
            return false;
          }
          if (!this.checkVerifyCodeFormat()) {
            return false;
          }
          // 校验验证码
          const res = await  this.flowRequest({
            flowId: this.configurationData.bindPhoneFlowId,
            params: {
              // role: this.roleInfo,
              data: JSON.stringify({
                phone: this.data[itemKey],
                virifyCode: this.verificationCode,
              }),
            },
          });
          const { data = {}, msg: retMsg, ret: resRet } = res;
          if (resRet !== 0 && retMsg) {
            this.$alert({ msg: retMsg });
            return false;
          }
          const { ret, msg } = data || {};
          if (ret !== 0) {
            this.$alert({ msg: msg || '操作失败' });
            return false;
          }

          if (this.timeClock) {
            this.codeTime = 0;
            clearInterval(this.timeClock);
          }
        }
        // 校验一致字段名
        if (pre.checkKey) {
          const checkList = this.questionConfig.filter((checkItem) => {
            const checkItemKey = checkItem.key === 'custom' ? checkItem.inputKey : checkItem.key;
            return checkItemKey === pre.checkKey;
          });
          if (checkList.length > 0) {
            const checkKey = checkList[0].key === 'custom' ? checkList[0].inputKey : checkList[0].key;
            if (this.data[itemKey] !== this.data[checkKey]) return this.$alert(`${pre.title}校验不一致!`);
          }
        }
      }
      const response = await this.flowRequest({
        flowId: this.flowId,
        params: {
          role: this.roleInfo,
          data: JSON.stringify({
            form_tag: this.formTag,
            questionnaire_data: JSON.stringify(this.data),
          }),
        },
      });
        // // 上报批量兑换切换
      !this.$isInEditor
          && this.reportCustomEvent({
            ceibaComponentId: `${this.id}`,
            ceibaComponentUid: this.uid,
            eventId: 1045,
          });
      if (response.ret !== 0) {
        this.alert(response.data.msg || response.msg);
      } else if (response.ret === 0) {
        this.query();
        this.refreshQua(); // 刷新礼包
        // const node = this.$refs.questionnaireOuter;
        // /* eslint no-underscore-dangle: ["error", { "allow": ["_prevClass"] }]*/
        // if (node.parentNode && node.parentNode._prevClass !== 'page-content') {
        //   const parentNode = node.parentNode?.parentNode?.parentNode;
        //   /* eslint no-underscore-dangle: ["error", { "allow": ["_prevClass"] }]*/
        //   if (parentNode._prevClass.split(' ')[0] === 'ceiba-dialog-container-container') {
        //     parentNode.remove();
        //   }
        // }
        if (this.configurationData.link) {
          window.location.href = this.configurationData.link;
        }
        this.alert(response.msg || this.birMsg);
        this.isFormShow = false;
      }
    },
    /**
       * 多选
       * @param {String} key 传入的单个组件key值
       * @param {String} value 传入的单个组件value值
       * @param {Number} maxNum 传入的单个组件maxNum值
       */
    checkCheckbox(key, value, maxNum) {
      const item = this.data[key].includes(value);

      if (item && this.data[key].length <= maxNum) {
        this.data[key].splice(this.data[key].indexOf(value), 1);
      } else if (!item && this.data[key].length < maxNum) {
        this.data[key].push(value);
      } else if (!item && this.data[key].length >= maxNum) {
        return this.$toast(`至多选择${maxNum}项`);
      }
    },
    /**
       * 单选
       * @param {String} key 传入的单个组件key值
       * @param {String} value 传入的单个组件value值
       */
    checkRadio(key, value) {
      this.$set(this.data, key, value);
    },
    /**
       * 初始化data
       */
    dataInit() {
      this.questionConfig.forEach((pre) => {
        Object.keys(pre).forEach((item) => {
          if (item === 'key') {
            if (pre.type === 'checkbox') {
              this.$set(
                this.data,
                pre[item] === 'custom' ? pre.inputKey : pre[item],
                [],
              );
              return false;
            }
            this.$set(
              this.data,
              pre[item] === 'custom' ? pre.inputKey : pre[item],
              '',
            );
          }
        });
      });
      console.log('data', this.data);
    },
    /**
       * 选择地址
       * @param {Object} siteInfo 城市地址
       * @param {String} siteInfo.province 省级地址
       * @param {String} siteInfo.city 市级地址
       * @param {String} siteInfo.area 区/县地址
       * @param {String} key 传入的单个组件key值
       */
    setSite(siteInfo, key) {
      console.log('siteInfo', siteInfo);
      if (!siteInfo) {
        this.data[key] = '';
        return false;
      }
      console.log(this.data[key]);
      this.siteInfo = siteInfo;
      const { province, city, area } = this.siteInfo;
      this.data[key] = `${province}-${city}-${area}`;
    },
    /**
       * 选择日期
       * @param {Object} birthdayInfo 日期
       * @param {String} birthdayInfo.year 年
       * @param {String} birthdayInfo.month 月
       * @param {String} birthdayInfo.day 日
       * @param {String} key 传入的单个组件key值
       */
    setBirthDay(birthdayInfo, key) {
      console.log('birthdayInfo', birthdayInfo);
      this.birthdayInfo = birthdayInfo;
      const { year, month, day } = this.birthdayInfo;
      if (year && month && day) {
        this.data[key] = `${year}-${month}-${day}`;
      } else {
        this.data[key] = '';
      }
    },
    // 弹窗表单
    showFormDlg() {
      if (this.formStatus === 'apply') {
        this.isFormShow = true;
        this.query();
        this.initButton();
      }
    },
    closeBtnClick() {
      this.isFormShow = false;
    },
    checkAuthRadio() {
      this.authStatus = !this.authStatus;
    },
  },
};
</script>
<style lang="scss">
  @import './styles.scss';
</style>
